@if(isBase64){
<img [src]="src" [ngClass]="class" [style.width.px]="size" />
}
@else{
<img [src]="'assets/img/'+src" [ngClass]="class" [style.width.px]="size" />
}
